var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#EBEEF5",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1677 10.9217L6.48382 12.6056C5.11761 13.9718 5.11761 16.1869 6.48382 17.5531V17.5531C7.85004 18.9193 10.0651 18.9193 11.4313 17.5531L13.1928 15.7916C14.5091 14.4753 14.5091 12.3411 13.1928 11.0248V11.0248L13.1025 10.9344",
    stroke: "#4E5362",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8524 13.132L17.5363 11.4481C18.9025 10.0819 18.9025 7.86683 17.5363 6.50061V6.50061C16.1701 5.1344 13.955 5.1344 12.5888 6.50061L10.8273 8.26212C9.511 9.57844 9.511 11.7126 10.8273 13.0289V13.0289L10.9177 13.1193",
    stroke: "#4E5362",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink2);
export default __webpack_public_path__ + "static/media/link2.7a4673a50d514698d4ef4eb68faf93cb.svg";
export { ForwardRef as ReactComponent };